<template>
  <div class="hide-on-print">
		<!-- Page Title -->
		<page-title
			icon="ni ni-chart-bar-32"
			main="Relatórios"
			sub="Ticket Médio"
		>
    </page-title>

		<!-- Filter -->
    <card>
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label class="form-control-label d-block">A partir de</label>
            <el-date-picker
              v-model="filter.startDate"
              type="date"
              placeholder="Data início"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              :editable="true"
            />
          </div>
          <span class="text-danger error-startDate" v-if="filter.startDate && filter.endDate && new Date(filter.startDate) > new Date(filter.endDate)">
            Data início deve ser menor ou igual a data fim
          </span>
        </div>
        <div class="col-md-5">
          <div class="form-group">
            <label class="form-control-label d-block">Até</label>
            <el-date-picker
              v-model="filter.endDate"
              type="date"
              placeholder="Data Fim"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              rules="required"
              :editable="true"
            />
          </div>
        </div>
        <div class="col-md-2">
          <div style="margin-top: 1.8rem">
            <base-button icon type="purple" @click="updatesSelectedDate" :disabled="validDateRule" style="width: 100%">
              <span class="btn-inner--text text-white">Pesquisar</span>
            </base-button>
          </div>
        </div>
      </div>
    </card>
    <average-ticket-card
      :startDate="startDate"
      :endDate="endDate"
    />
	</div> 
</template>

<script>
import { DatePicker } from "element-ui";
import PageTitle from "@/layouts/PageTitle"
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import BarChart from "@/components/Charts/BarChart";
import AverageTicketCard from "@/components/AverageTicketCard.vue";

export default {
  name: 'average-ticket',
  components: { 
    PageTitle,
    Multiselect,
    [BarChart.name]: BarChart,
    [DatePicker.name]: DatePicker,
    AverageTicketCard,
  },
  data() {
    return {
      filter: {
        startDate: null,
        endDate: null,
        },
      loadingReportData: false,
      loadingAnosafras: false,
      reportData: [],
      chartDataTypes: {
        'enterprises': 'Empresas',
        'managers': 'Gerentes Comerciais',
        'salesmen': 'Vendedores',
        'consultants': 'Consultores',
      },
      q: {},
      anosafras: [],
      selectedAnosafra: null,
      startDate: null,
      endDate: null,
    }
  },
  computed: {
    validDateRule(){
      return this.filter.startDate && this.filter.endDate && new Date(this.filter.startDate) > new Date(this.filter.endDate)
    }
  },
  mounted () {
    this.setData();
  },
  methods: {
    setData() {
      let q = {};
      this.filter.startDate ? (q.start_date = this.filter.startDate) : null;
      this.filter.endDate ? (q.end_date = this.filter.endDate) : null;
    },
    updatesSelectedDate() {
      this.startDate = this.filter.startDate
      this.endDate = this.filter.endDate;
    },
  }
}
</script>
<style scoped>
.error-startDate {
  font-size: 0.8rem;
  margin-top: -0.8rem;
  margin-left: 0.5rem;
  display: block;
}
</style>